<template>
  <div class="layerPop" id="popPwCheck" v-if="isVisible">
    <div class="popWrap">
      <div class="popBox popType1">
        <div class="popHead">
          <p class="popTit">회원 정보 변경</p>
        </div>
        <div class="popCon">
          <div class="tabStyle1">
            <table>
              <caption>
                회원 정보 변경
              </caption>
              <colgroup>
                <col width="140" />
                <col width="*" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">
                    <label for="password">비밀번호 확인</label>
                  </th>
                  <td>
                    <div class="inpTxt typeReq">
                      <input
                        maxlength="20"
                        v-model="state.oldPwd"
                        type="password"
                        id="oldPwd"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="popBtn">
          <a class="btnType sizeS colorB" @click="send()"><span>확인</span></a>
        </div>
        <slot></slot>
        <button type="button" class="popClose" @click="close()">
          <span class="hide">닫기</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, inject, onMounted, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import CryptoJS from "crypto-js";
import { sessionUserInfo, load } from "@/common/sessionFactory";

const axios = inject("axios");
const router = useRouter();
const state = reactive({
  oldPwd: "",
  newPwd: "",
  newPwdChk: "",
  login_id: "",
  biz_no: "",
  birth_ymd: "",
  tel_no2: "",
  tel_no3: "",
  sType: "",

  keyResult: {},
});
const isVisible = ref(false);
const swalAlert = inject("swalAlert");

const emits = defineEmits(["update:data", "close"]);

const open = async (object) => {
  state.oldPwd = "";
  isVisible.value = true;
  state.login_id = object.login_id;
  state.biz_no = object.biz_no;
  state.birth_ymd = util.formatDate(object.birth_ymd, "yymmdd");
};

const send = async () => {
  if (_.isEmpty(state.oldPwd)) {
    return swalAlert("비밀번호를 입력하세요.");
  }
  state.keyResult = await axios.json("/getCryptoKey.do");

  const key = state.keyResult.data.key;
  const iv = state.keyResult.data.iv;
  const keyBytes = CryptoJS.enc.Base64.parse(key);
  const ivBytes = CryptoJS.enc.Base64.parse(iv);

  const encryptedId = CryptoJS.AES.encrypt(state.login_id, keyBytes, {
    iv: ivBytes,
    mode: CryptoJS.mode.CBC,
  }).toString();
  const encryptedPw = CryptoJS.AES.encrypt(state.oldPwd, keyBytes, {
    iv: ivBytes,
    mode: CryptoJS.mode.CBC,
  }).toString();
  const encryptedBdt = CryptoJS.AES.encrypt(state.birth_ymd, keyBytes, {
    iv: ivBytes,
    mode: CryptoJS.mode.CBC,
  }).toString();

  let param = {};
  param.encId = encryptedId;
  param.encPw = encryptedPw;
  param.encBdt = encryptedBdt;
  param.login_typ_cd = state.athTypeCd;
  param.flag = "T";
  param.skipPwChg = "N";
  axios.json("/login.do", param).then(async function (result) {
    if (result.data.state == "Y") {
      close("Y");
    } else {
      return swalAlert("비밀번호가 틀립니다.");
    }
  });
};

const close = (arg) => {
  isVisible.value = false;
  emits(arg == "Y" ? "closeCall" : "close");
};
defineExpose({ open, close });
</script>
